import { utils } from '@digital-commerce/shared-utils'

import { ModuleTranslationProvider } from '../../../contexts/ModuleTranslation'
import CodeRedemption from './CodeRedemption'
import translations from './locales'
import useCart from '../../../hooks/useCart'
import useFeatureFlags from '../../../hooks/useFeatureFlags'
import { hasFIFAProvisioner } from '../../../utils/cart'

const {
  cart: { isHSCart }
} = utils

const CodeRedemptionContainer = () => {
  const { cart } = useCart()
  const { data: featureFlags } = useFeatureFlags()
  const shouldDisplay =
    isHSCart(cart) && hasFIFAProvisioner(cart) && featureFlags.enableCodeRedemption
  if (!shouldDisplay) {
    return null
  }
  return (
    <ModuleTranslationProvider translations={translations} module="coder-redemption">
      <CodeRedemption />
    </ModuleTranslationProvider>
  )
}

export default CodeRedemptionContainer
